import React from "react";
import { useTranslation } from "react-i18next";
import { useBranding } from "../../store/branding-context";
import { appConfig } from "../../configs/tenantConfig";
import { automationTestIds } from "../../testing/automationTestIds";
import OrganisationBrandLogo from "../OrganisationBrandLogo/OrganisationBrandLogo";
import ProfileIcon from "../../resources/icons/profile-circle.svg";

const AuthBrandHeader = ({ accountName = "", accountPhotoSrc = "" }) => {
  const { t } = useTranslation();
  const { organisationData, isLoading: isBrandingLoading } = useBranding();

  const organisationName =
    organisationData?.organisation_name?.trim() || appConfig.appName;
  const hasOrganisationName = Boolean(
    organisationData?.organisation_name?.trim(),
  );
  const showOrganisationLogoSlot =
    isBrandingLoading ||
    Boolean(organisationData?.organisation_logo) ||
    hasOrganisationName;

  if (!showOrganisationLogoSlot && !accountName) {
    return null;
  }

  return (
    <header
      id={automationTestIds.authBrandHeader}
      className="w-full border-b-[1.5px] bg-cfSecondary"
    >
      <div className="mx-auto flex h-[4rem] items-center gap-3 px-4 sm:h-[5rem] sm:px-6 lg:px-8">
        {showOrganisationLogoSlot && (
          <OrganisationBrandLogo
            alt={t("authPages:organisation_logo_alt", {
              organisation: organisationName,
            })}
            className="h-12 w-auto max-w-[150px] object-contain object-left sm:h-16 sm:max-w-[220px]"
            skeletonClassName="h-12 w-32 max-w-[150px] sm:h-16 sm:w-40 sm:max-w-[220px]"
            testId={automationTestIds.authBrandHeader}
            fallback={
              hasOrganisationName ? (
                <span
                  id={automationTestIds.authBrandHeaderOrgName}
                  className="max-w-[150px] truncate text-xl font-semibold text-cfHeadingText sm:max-w-[220px]"
                >
                  {organisationName}
                </span>
              ) : null
            }
          />
        )}

        {accountName && (
          <div
            id={automationTestIds.authBrandHeaderAccount}
            className="ml-auto flex min-w-0 max-w-xs items-center gap-1 text-md text-cfNavBarText"
          >
            {accountPhotoSrc ? (
              <img
                className="h-8 w-8 shrink-0 rounded-full object-cover"
                src={accountPhotoSrc}
                alt=""
              />
            ) : (
              <img
                src={ProfileIcon}
                alt=""
                srcSet=""
                className="w-7 shrink-0 text-gray-400"
              />
            )}
            <span className="sr-only">{t("authPages:signed_in_as")}</span>
            <p className="truncate">{accountName}</p>
          </div>
        )}
      </div>
    </header>
  );
};

export default AuthBrandHeader;
